import {classNames} from "../../../util/util-helpers";
import PopOver from "../../popover";
import ChevronDownIcon from "@heroicons/react/20/solid/ChevronDownIcon";
import React from "react";

export default function ButtonSplit({label, onClick, menuContent}) {
    return <div className="flex relative">
        <button
            className={
                classNames(
                    "btn btn-outline hover:bg-tm-gray-50 z-10 rounded-r-none relative -right-px"
                )
            }
            onClick={onClick}
        >
            {label}
        </button>
        <PopOver
            btnClass="relative inline-flex items-center rounded-r-btn bg-inverse px-2 py-2 text-primary ring-1 ring-inset ring-primary hover:bg-tm-gray-50 hover:z-10 hover:ring-primary-tint cursor-pointer"
            BtnIcon={ChevronDownIcon}
            btnIconClass="w-5 h-5 text-primary"
            widthClass="max-w-xs"
            positionClass="absolute translate-x-0 right-0"
        >
            <div
                className="bg-popup border border-tm-gray-300 rounded-card">
                {menuContent}
            </div>
        </PopOver>
    </div>
}